import { LocalStorage } from 'quasar'

export default {
  isAuthenticated: state => !!LocalStorage.getItem('access_token') || !!state.access_token,
  authStatus: state => state.status,
  // Lee del state (no de LocalStorage): un getter sin dependencias reactivas se cachea para
  // siempre y el boton biometrico nunca aparecia tras enrolar sin reiniciar la app.
  hasBiometricLoginEnabled: state => state.biometric_login_enabled
}
